<div class="p-2 light-blue-header d-flex flex-row justify-content-between modal-header">
    <div class="p-2 modal-title"><h5>Market {{edit?'Update':'Create'}}</h5></div>
    <button class="p-0 m-0 btn" style="line-height: .8; color: white" (click)="onCancel();onSaveMarket()" aria-label="Close">
        <i class="fa fa-window-close"></i>
    </button>
</div>

<div class="container-fluid busy-overlay-parent p-3" [ngClass]="bProcessing?'disabled':''">
    <div *ngIf="bProcessing" class="font-weight-bold busy-overlay">
        <i class="fa fa-spinner fa-spin"></i>&nbsp;Please wait...
    </div>
    <form [formGroup]="marketForm" class="card p-2" (submit)="submitMarket()">
        <div class="input-group input-group-sm flex-column align-middle">

            <div class="p-2">
                <label for="nameInput" class="form-label">Name:</label>
                <input type="text"  name="name" class="form-control" id="nameInput"
                       formControlName="name" required
                       [ngClass]="{ 'invalid-input': marketForm.controls['name'].invalid && (marketForm.controls['name'].dirty || marketForm.controls['name'].touched)}">
                <span *ngIf="marketForm.controls['name'].invalid && marketForm.controls['name'].dirty" class="text-danger small font-italic">* Required</span>
            </div>
            <div class="p-2">
                <label for="timezoneInput" class="form-label">Timezone:</label>
                <select formControlName="timezone" class="form-control" id="timezoneInput" required   >
                    <option value="">--Select Timezone--</option>
                    <option *ngFor="let single_timezone of timezones" [value]="single_timezone.name">{{single_timezone.description}}</option>
                </select>
                <span *ngIf="marketForm.controls['timezone'].invalid && marketForm.controls['timezone'].dirty"
                      class="text-danger small font-italic">* Required</span>
            </div>
            <div class="p-2">
                <button type="submit"  class="btn btn-primary">{{edit?"Update":"Save"}}</button>
            </div>
        </div>


    </form>
</div>
